import { useContext } from 'react'
import PresentationNavContext from './PresentationNavContext'

export default function usePresentationNav() {
  return useContext(PresentationNavContext)
}
